import useIsScreenSize from 'js/hooks/use-is-screen-size';

import ContentArea from 'components/content-area/ContentArea';
import Link from 'components/link/Link';
import TabList from 'components/tabs/TabList';
import TabListItem from 'components/tabs/TabListItem';
import TabsMobile from 'components/tabs-mobile/TabsMobile';

import { IOfficeListBlock } from 'source/NFR.types';

const OfficeListBlock: React.FC<IOfficeListBlock> = ({ links = [], selector, offices }) => {
  const isMobile = useIsScreenSize('mdMax');

  return (
    <div className="office-list-block">
      {isMobile ? (
        <TabsMobile {...selector} tabs={links} />
      ) : (
        links.length > 0 && (
          <TabList className="event-list-page--tab-list non-breakable-tab-columns">
            {links?.map(({ isActive, link, id }, index) => (
              <TabListItem
                key={id}
                isCurrent={isActive}
                length={links.length}
                index={index}
                currentIndex={links.findIndex(({ isActive }) => isActive)}
              >
                <Link theme={isActive ? 'black' : undefined} {...link} />
              </TabListItem>
            ))}
          </TabList>
        )
      )}
      <div className="office-list-block--offices">
        <ContentArea
          additionalItemProps={{
            OfficeBlock: { theme: 'largeMargin' }
          }}
          {...offices}
        />
      </div>
    </div>
  );
};

OfficeListBlock.displayName = 'OfficeListBlock';

export default OfficeListBlock;
